import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import {
  MeasureHighKind,
  MeasureClcType,
  AlmTypKind,
  GetVibrationSpecialNo,
  GetVibrationSpecialNoUnit,
  GetVibrationSpecialString,
  GetMeasureClcName,
  MeasureConanKind,
  PARTIAL_DISCHARGE_PLCNO,
  CcTypKind
} from '../../../../Constant';

import {
  GroupListType,
  GetTrendGroupList,
  GetTrendSetting,
  PutTrendGroupSetting,
  TM_TRD_GROUP_SET,
  V_TREND_SETTING_ITEM,
  JudgeInfo,
  PlcInfo,
  ColSetInfo,
  KIND_NO_NAME_SET,
  TrendSettingParameter
} from '../../../../function/GroupDataModel';

import { IsConanAirPlc, IsPartialDischargePlc } from '../../../../function/PlcNoModel';
import { SET_PART_DIS } from '../../MeasureSetting/PartialDischargeCollection/PartialDischargeCollection';

export type CLC_TYP_SET = {
  TYP_NO: number;
  TYP_NAME: string;
  TYP_INVALID: number;
}

/**
 * グループコンボボックスリスト作成
 * @param groups
 * @returns
 */
export const CreateGroupNoComboList = (groups: TM_TRD_GROUP_SET[]): ComboBoxItemType[] => {
  return groups.map<ComboBoxItemType>((grp) => {
    return { index: grp.GROUP_NO, name: grp.GROUP_NO.toString() };
  });
};

/**
 *V_TREND_SETTING_ITEMのデフォルトデータを返す
 * @returns
 */
export const CreateInitTrendSettingItem = (groupNo: number): V_TREND_SETTING_ITEM => {
  return {
    GROUP_NO: groupNo,
    PEN_NO: 0,
    DSP_FLG: 0,
    DSP_COLOR: 0,
    GRP_LOW: 0,
    GRP_HIGH: 0,
    SCALE_ON: 0,
    PLC_NO: 0,
    AI_CARD: 0,
    AI_CH: 0,
    TYP_NO: 0,
    MCLC_TYP_ID: 0,
    SET_NO: 0,
    DEV_INDEX: 0,
    DEV_NO: '',
    DEV_NAME: '',
    ITM_NAME_NO: 0,
    ITM_NAME: '',
    EMC_ITM_NAME_NO: 0,
    EMC_ITM_NAME: '',
    EMC_UNIT: '',
    CLC: 0,
    KIND: 0,
    KIND_NO: 0,
    UNIT: '',
    RH: 0,
    RL: 0,
    MUL: 0,
    SPEED: 0,
    MES_NAME: '',
    LOG_INT: 0,
  };
};

/**
 * ColSetInfoのデフォルトデータを返す
 */
export const CreateInitColSetInfo = (): ColSetInfo => {
  var col: ColSetInfo = {
    KIND_NO: 0,
    DEV_INDEX: 0,
    ITM_NAME_NO: 0,
    CLC: 0,
    PLC_NO: 0,
    AI_CARD: 0,
    AI_CH: 0,
    SET_NO: 0,
    SPEED: 0,
    UNIT: '',
    VALID: 0,
  };
  return col;
};

/**
 * グループ設定のデフォルトデータを返す
 * @returns
 */
export const CreateInitGroupSet = (gropuNo: number): TM_TRD_GROUP_SET => {
  const newGrp: TM_TRD_GROUP_SET = {
    GROUP_NO: gropuNo,
    GROUP_NAME: '',
    DSP_FLG: 1,
    DSP_COLOR: getColorCode(0, 0, 64),
    AUT_UPDATE: 0,
    DSP_SPAN: 0,
  };

  return newGrp;

};

/**
 * 指定した行のデフォルト色を返す
 * @param indexNo
 */
export const GetDefaultPenColor = (indexNo: number): number => {
  switch (indexNo) {
    case 1:
      return getColorCode(255, 0, 0);
    case 2:
      return getColorCode(0, 0, 255);
    case 3:
      return getColorCode(0, 128, 0);
    case 4:
      return getColorCode(0, 255, 255);
    case 5:
      return getColorCode(128, 0, 128);
    case 6:
      return getColorCode(128, 128, 0);
    case 7:
      return getColorCode(255, 255, 0);
    case 8:
      return getColorCode(0, 128, 128);
    default:
      return getColorCode(255, 0, 0);
  }
}
/**
 * 指定した空コードを返す
 * @param r
 * @param g
 * @param b
 * @returns
 */
const getColorCode = (r: number, g: number, b: number): number => {
  return r + (g << 8) + (b << 16);
};

/**
 * 閾値取得
 * @param alarmLimits
 * @param plcNo
 * @param aiCard
 * @param aiCh
 * @param clc
 * @param typeNo
 * @param kindNo
 * @returns
 */
export const GetLimit = (
  alarmLimits: JudgeInfo[],
  plcNo: number,
  aiCard: number,
  aiCh: number,
  clc: number,
  typeNo: number,
  kindNo: number,
  mclcTypId: number
): JudgeInfo | undefined => {
  if (kindNo === MeasureHighKind.VIBRATION_SPD) {
    clc = 5; //データ種別　速度固定
  } else if (kindNo === MeasureHighKind.VIBRATION_DSP) {
    clc = 6; //データ種別　変位固定
  }
  const limit = alarmLimits.find((al) => {
    if (al.PLC_NO == plcNo && al.AI_CARD == aiCard && al.AI_CH == aiCh && al.MCLC_TYP_ID == mclcTypId) {
      // if (clc == 7) {
      //   // dB差分
      //   return al.CLC_TYP == 7 && al.ALM_TYP_NO == typeNo;
      // } else if (clc == 99) {
      //   // 特殊値
      //   return al.CLC_TYP == 1 && al.ALM_TYP_NO == typeNo;
      // } else {
      //   // 上記以外
      //   return al.CLC_TYP == clc && al.ALM_TYP_NO == typeNo;
      // }
      return al.CLC_TYP == clc && al.ALM_TYP_NO == typeNo;
    } else {
      return false;
    }
  });

  return limit;
};


/**
 * 単位取得
 * @param colSets
 * @param plc
 * @param aicard
 * @param aich
 * @param clc
 * @param kindNo
 * @returns
 */
export const GetUnit = (
  colSets: ColSetInfo[],
  plc: number,
  aicard: number,
  aich: number,
  clc: number,
  kindNo: number
): string => {
  if (IsConanAirPlc(String(plc))) {
    return GetUnitWithClcConal(kindNo);
  }
  if (IsPartialDischargePlc(String(plc))) {
    console.debug(["IsPartialDischargePlc", clc, plc])
    return GetPartialDischargeUnit(clc);
  }
  var col = colSets.find(
    (col) => col.PLC_NO == plc && col.AI_CARD == aicard && col.AI_CH == aich && col.KIND_NO == kindNo
  );
  if (col) {
    return GetUnitWithClc(col.PLC_NO, col.UNIT, clc, kindNo, 0);
  }
  return '';
};

/**
 * 部分放電の単位取得
 * @param clc 
 * @param plc 
 * @returns 
 */
export const GetPartialDischargeUnit = (clc: number): string => {
  if ((clc === CcTypKind.PD_TYP_NO_CLC_MAXVALUE || clc === CcTypKind.PD_TYP_NO_CLC_PDVALUE)) {
    return "V";
  }
  return "";
};

/**
 * 各演算タイプの単位文字列を返す
 * @param unit
 * @param clc
 * @param kind
 * @returns
 */
export const GetUnitWithClc = (plcNo: number, unit: string, clc: number, kindNo: number, kind: number) => {
  if (IsConanAirPlc(String(plcNo))) {
    return GetUnitWithClcConal(kindNo);
  }
  if (clc == 5) {
    /* 速度値 */
    return 'mm/s';
  } else if (clc == 6) {
    /* 変位値 */
    return 'μm';
  } else if (clc == 7) {
    /* 変位値 */
    return 'dB';
  } else if (kind == 1) {
    /* 速度値 */
    return 'mm/s';
  } else if (kind == 2) {
    /* 変位値 */
    return 'μm';
  } else {
    return unit;
  }
};
/**
 * コナンエアの場合、単位固定
 * @param unit
 * @param clc
 * @param kind
 * @returns
 */
export const GetUnitWithClcConal = (kindNo: number) => {
  if (MeasureConanKind.SOKUDO_X === kindNo
    || MeasureConanKind.SOKUDO_Y === kindNo
    || MeasureConanKind.SOKUDO_Z === kindNo
    || MeasureConanKind.SOKUDO_3D === kindNo
    || MeasureConanKind.SOKUDO_FFT_X === kindNo
    || MeasureConanKind.SOKUDO_FFT_Y === kindNo
    || MeasureConanKind.SOKUDO_FFT_Z === kindNo
    || MeasureConanKind.SOKUDO_FFT_3D === kindNo
  ) {
    return 'mm/s';
  }
  else {
    return 'm/s2';
  }
};

/**
 *特殊データを追加
 振動（速度）振動（変位）
 */
export const CreateSpecialDatTrendSettingParameter = (target: TrendSettingParameter, translation: any) => {
  //特殊項目追加
  const spdkind: KIND_NO_NAME_SET = {
    SPEED: 2,
    NAME_NO: MeasureHighKind.VIBRATION_SPD,
    MES_NAME: GetVibrationSpecialString(MeasureHighKind.VIBRATION_SPD, translation),
  };
  const dspkind: KIND_NO_NAME_SET = {
    SPEED: 2,
    NAME_NO: MeasureHighKind.VIBRATION_DSP,
    MES_NAME: GetVibrationSpecialString(MeasureHighKind.VIBRATION_DSP, translation),
  };
  target.KIND_NO_NAME_SETs.push(spdkind);
  target.KIND_NO_NAME_SETs.push(dspkind);
  target.MeasKinds.push({ Key: target.MeasKinds.length + 1, Disp: spdkind.MES_NAME });
  target.MeasKinds.push({ Key: target.MeasKinds.length + 1, Disp: dspkind.MES_NAME });

  const copys = target.ColSetInfos.filter((r) => r.SPEED == 2 && r.KIND_NO == 1);
  if (copys != null) {
    for (let i in copys) {
      let temp1 = Object.assign(CreateInitColSetInfo(), copys[i]);
      temp1.KIND_NO = MeasureHighKind.VIBRATION_SPD;
      temp1.UNIT = GetVibrationSpecialNoUnit(temp1.KIND_NO, '');
      target.ColSetInfos.push(temp1);
      let temp2 = Object.assign(CreateInitColSetInfo(), copys[i]);
      temp2.KIND_NO = MeasureHighKind.VIBRATION_DSP;
      temp2.UNIT = GetVibrationSpecialNoUnit(temp2.KIND_NO, '');
      target.ColSetInfos.push(temp2);
      console.debug(['mesRt,temp1,temp2,mesRet', temp1, temp2, target.ColSetInfos]);
    }
  }
}
